/**
 * Event Emitter - Pub/Sub pattern for component communication
 */
export class EventEmitter {
    constructor() {
        this._events = new Map();
    }

    on(event, listener) {
        if (!this._events.has(event)) {
            this._events.set(event, []);
        }
        this._events.get(event).push(listener);

        // Return unsubscribe function
        return () => this.off(event, listener);
    }

    off(event, listener) {
        if (!this._events.has(event)) return;
        const listeners = this._events.get(event);
        const index = listeners.indexOf(listener);
        if (index > -1) {
            listeners.splice(index, 1);
        }
    }

    emit(event, ...args) {
        if (!this._events.has(event)) return;
        for (const listener of this._events.get(event)) {
            try {
                listener(...args);
            } catch (error) {
                console.error(`Error in event listener for "${event}":`, error);
            }
        }
    }

    once(event, listener) {
        const wrapper = (...args) => {
            this.off(event, wrapper);
            listener(...args);
        };
        return this.on(event, wrapper);
    }
}
